import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  assetDataService,
  riskSharedModelService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './assign-risk-dialog.controller';
import template from './assign-risk-dialog.html';
import nameMessagesTpl from './name.messages.html';
import risk from '../../riskAdministration/risk';
import editRiskDialog from '../../riskAdministration/dialog.editRiskDialog';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    asset,
    risks,
  }) {
    return {
      controller,
      controllerAs: 'assignRiskDialogVM',
      locals: {
        asset,
        risks,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.assetAdministration.assignRiskDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  riskDataService,
  assetDataService,
  riskSharedModelService,
  editRiskDialog,
  copy,
  alerts,
  risk
])
  .service('assignRiskDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.admin.assetAdministration.assignRiskDialog created');
